import { combineReducers } from 'redux'
import Product from './product'


const reducers = combineReducers({
    Product,
    
})

export default reducers